import type React from 'react';

import { RecommendedDecisionMakerCard } from './components/RecommendedDecisionMakerCard';
import { useRecommendedDecisionMakerList } from './hooks/useRecommendedDecisionMakerList';

type RecommendedDecisionMaker = {
	normalizedId: string;
	canonicalPetitionTargetId: string | null;
	name: string;
	type: 'PERSON' | 'ORG';
	title: string | null;
	photoUrl: string | null;
};

type RecommendedDecisionMakerListProps = {
	recommendedDecisionMakers: RecommendedDecisionMaker[];
	petitionId: string;
	trackingContext: string;
};

export const RecommendedDecisionMakerList: React.FC<RecommendedDecisionMakerListProps> = ({
	recommendedDecisionMakers,
	petitionId,
	trackingContext,
}) => {
	const { data, actions } = useRecommendedDecisionMakerList(recommendedDecisionMakers, petitionId, trackingContext);
	return (
		<div className="mt-4 flex flex-col items-stretch gap-4">
			{recommendedDecisionMakers.map((dm) => {
				const dmId = dm.normalizedId;
				const state = data.recommendedDecisionMakerListState[dmId];
				if (!state) return null;
				return (
					<RecommendedDecisionMakerCard
						key={dmId}
						state={state}
						onAdd={actions.addRecommendedDecisionMaker}
						onRemove={actions.removeRecommendedDecisionMaker}
					/>
				);
			})}
		</div>
	);
};
